import { getFarms } from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/getFarms';
import { getToken } from 'app/agriculture/contexts/RequiredStartupProviders/TokenContext/getToken';

export const startupQueries = {
    token: {
        queryKey: ['/auth/api-token-auth/'],
        queryFn: getToken,
        retry: false,
    },
    farms: {
        queryKey: ['/farms/'],
        queryFn: getFarms,
        retry: false,
    },
};
